import http from "../http";
import Service from "../../Service";

export default class PermissionService extends Service {
    my() {
        return http.get("v2/commons/permissions", {
            headers: this.getHeaders(),
        });
    }
}
